import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {FirmwareGetSchema} from '../../../../api/DBSchema/Firmware';
import {dateAndTimeToString} from '../../../../utils/utils';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';

const pageSchema = FirmwareGetSchema.pages.history;
const pageId = pageSchema.pageId;

function FirmwareGeneral({
    firmwareObject,
}) {
    const { t } = useTranslation();

    const pageData   = firmwareObject[pageId];
    const createTime = pageData[pageSchema.createTime];
    const lastTime   = pageData[pageSchema.lastTime];

    return (
        <EditorLayout>
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(createTime, true)}
                label={t('SMC_GEN_STATS_CREATETIME')}
            />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(lastTime, true)}
                label={t('SMC_GEN_STATS_LASTMOD')}
            />
        </EditorLayout>
    )
}

export default FirmwareGeneral;